<template>
  <div class="row d-flex justify-content-center">
    <div class="col-md-10">
      <h2 class="mt-5 mb-5">
        {{ $t(LangConstants.signup_up_forms_menu_item) }}
      </h2>

      <b-tabs content-class="" class="custom-tab-control">
        <b-tab active title="first">
          <template #title>
            <i class="fa fa-list" aria-hidden="true"></i>
            &nbsp; <span>{{ $t(LangConstants.overview_tab_title) }}</span>
          </template>

          <div class="container-fluid">
            <template v-for="signUpForm in signUpForms">
              <sign-up-forms-list-item v-bind:key="signUpForm.id" id="3" :title="signUpForm.title" :imgUrl="getFormsImageUrl(signUpForm.logo)" :url="signUpForm.url" :descTitle="$t(LangConstants.signup_form_list_item_custom_description_title)" :description="signUpForm.description" @showEditForm="showEditForm(signUpForm.id)" @deleteForm="deleteForm(signUpForm.id)" @copyInputText="copyFormUrl(signUpForm.id)" />
            </template>

            <no-data-box v-if="signUpForms != null && signUpForms.length == 0">
              <h5 class="mb-0">
                {{ $t(LangConstants.signup_forms_no_data_text) }}
                <b>”{{ $t(LangConstants.signup_forms_no_data_add_form_text) }}”</b>
              </h5>
            </no-data-box>
          </div>
        </b-tab>

        <b-tab title="Second">
          <template #title>
            <i class="fa fa-plus" aria-hidden="true"></i>
            &nbsp;
            <span>{{ $t(LangConstants.signup_forms_no_data_add_form_text) }}</span>
          </template>

          <sign-up-forms-wizard />
        </b-tab>
      </b-tabs>
    </div>
    <div></div>

    <b-modal :title="modalTitle" v-model="modalShow" size="xl" hide-footer ref="editModal" static="true">
      <div class="container-fluid d-flex justify-content-center form-base">
        <div class="col-12 form2">
          <div class="row">
            <div class="col-md-12">
              <div class="mb-4">
                <my-input id="custom-title" name="my-name" mandatory="true" :label="$t(LangConstants.custom_title_input_label)" :placeholder="$t(LangConstants.custom_title_input_placeholder)" inlinerows="false" classes="bg-gray" ref="customTitle"></my-input>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="mb-4">
                <my-text-area id="my-name" name="my-name" mandatory="true" :label="$t(LangConstants.custom_description_input_label)" :placeholder="$t(LangConstants.custom_description_input_placeholder)" inlinerows="false" classes="bg-gray" ref="customDescription"></my-text-area>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="mb-4">
                <file-input id="fileformupdate" inlinerows="false" :label="$t(LangConstants.logo_input_label)" :placeholder="$t(LangConstants.logo_input_placeholder)" :dropplaceholder="$t(LangConstants.logo_input_drop_placeholder)" ref="ulogo"></file-input>
              </div>
            </div>
          </div>

          <div class="row">
            <template v-for="mfieldset in mandatoryFields">
              <div v-for="mfield in mfieldset.fields" v-bind:key="mfield" class="col-md-6">
                <div class="mb-4">
                  <my-input :id="mfield.value" name="my-name" mandatory="true" :label="$t(mfield.label)" :placeholder="$t(mfield.placeholder)" inlinerows="false" classes="bg-gray" :type="mfield.type"></my-input>
                </div>
              </div>
            </template>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-4">
                <select-input-group id="country-sel" name="country-sel" mandatory="true" :label="$t(LangConstants.add_other_fields_input_group_label)" placeholder="" :data="nonMandatoryFields" inlinerows="false" classes="bg-gray" btn_fa="plus-circle" :btn_label="$t(LangConstants.add_fields_button_label)" btn_variant="box-general-grey" btn_classes="mr-1" btn_width="100%" @click="addNonMandatoryField"></select-input-group>
              </div>
            </div>
          </div>

          <hr />

          <div class="row">
            <div v-for="nmmfields in nonMandatoryFields" v-bind:key="nmmfields" class="col-md-12" :data-fieldset="nmmfields.value">
              <div class="row" v-if="SelectedNonMandatory.includes(nmmfields.value)">
                <div v-if="nmmfields.label" class="col-md-12 mt-2 mb-2">
                  <div class="row">
                    <div class="col-md-6">
                      <h4>{{ $t(nmmfields.label) }}</h4>
                    </div>
                    <div v-if="nmmfields.fields.length > 1" class="col-md-6 d-flex align-items-end">
                      <my-button fa="trash" :label="$t(LangConstants.delete_fields_button_label)" variant="box-general-grey" classes="mb-3" height="47px" :width="btn_width" @onClick="deleteNonMandatoryField(nmmfields.value)"></my-button>
                    </div>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="row">
                    <div :id="nmmfields.value" v-for="nmmfield in nmmfields.fields" v-bind:key="nmmfield" class="col-md-6">
                      <my-text-area v-if="nmmfield.type == 'textarea'" :id="nmmfield.value" name="my-name" :label="$t(nmmfield.label)" :placeholder="$t(nmmfield.placeholder)" inlinerows="false" classes="bg-gray" :type="nmmfield.type" ref="customCompanyList" :value="currentCompanies" v-model="currentCompanies"></my-text-area>
                      <my-input v-if="nmmfield.type != 'checkbox' && nmmfield.type != 'textarea'" :id="nmmfield.value" name="my-name" mandatory="true" :label="$t(nmmfield.label)" :placeholder="$t(nmmfield.placeholder)" inlinerows="false" classes="bg-gray" :type="nmmfield.type"></my-input>
                      <my-checkbox v-if="nmmfield.type == 'checkbox'" id="orderCertificate" name="orderCertificate" inlinerows="false" :defaultText="$t(nmmfield.placeholder)" secondaryText="" checkedValue="1" uncheckedValue="0" :label="$t(nmmfield.label)"> </my-checkbox>
                    </div>
                    <div v-if="nmmfields.fields.length == 1" class="col-md-6 d-flex align-items-end">
                      <my-button fa="trash" :label="$t(LangConstants.delete_field_button_label)" variant="box-general-grey" classes="mb-3" height="47px" :width="btn_width" @onClick="deleteNonMandatoryField(nmmfields.value)"></my-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mb-4 row">
            <div class="col">
              <toggle-simple :label="$t(LangConstants.captcha_input_label)" :labelEnable="$t(LangConstants.yes_text)" :labelDisable="$t(LangConstants.no_text)" ref="captcha" />
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <my-button :label="$t(LangConstants.update_button_label)" fa="check" variant="solid-primary" classes="mr-1" height="46px" minwidth="100px" @onClick="updateForm"></my-button>
        <my-button :label="$t(LangConstants.cancel_button_label)" fa="ban" variant="box-general-grey" classes="mr-1" height="46px" minwidth="100px" @onClick="hideModal"></my-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/**
 * Signup Forms - Admin Page
 */
import "../../assets/scss/forms-base.scss";
import "../../assets/scss/tab-control.scss";
import common from "../../functions/index";
import Constants from "../../constants/index";

import SignUpFormsWizard from "../../components/organisms/SignUpFormsWizard.vue";
import SignUpFormsListItem from "../../components/organisms/SignUpFormsListItem.vue";

import MyButton from "../../components/atoms/Button.vue";
import MyInput from "../../components/atoms/Input.vue";
import MyCheckbox from "../../components/atoms/Checkbox.vue";
import ToggleSimple from "../../components/atoms/ToggleSimple.vue";
import MyTextArea from "../../components/atoms/TextArea.vue";

import SelectInputGroup from "../../components/organisms/SelectInputGroup.vue";
import FileInput from "../../components/atoms/File.vue";
import NoDataBox from "../../components/atoms/NoDataBox.vue";

export default {
  name: "company-account-home",

  async beforeCreate() {
    // await this.$store.dispatch("getUsers");
    // await this.$store.dispatch("getUsersByRoleManager");
    await this.$store.dispatch("getUsersByRoleTeamLead");
    await this.$store.dispatch("getUsersByRoleInstructor");
    await this.$store.dispatch("getCourses");
    await this.$store.dispatch("getSignupForms");
  },
  beforeMount() {},

  created() {},
  computed: {
    signUpForms() {
      var forms = this.$store.getters.allSignUpForms;

      if (forms != null && forms.length > 0) {
        forms.sort(function(a, b) {
          var c = new Date(a.created_at);
          var d = new Date(b.created_at);
          return d - c;
        });

        return forms;
      }

      return [];
    },
    currentCompanies() {
      return this.currentCompanyList;
    },
    courses() {
      return this.$store.state.courses;
    },
    formTitles() {
      return this.$store.state.formTitles;
    },
    mandatoryFields() {
      return this.$store.state.mandatoryFields;
    },
    nonMandatoryFields() {
      return this.$store.state.nonMandatoryFields;
    },
    // managers() {
    //   return this.$store.state.managers;
    // },
    // teamLeads() {
    //   return this.$store.state.teamLeads;
    // },
    LangConstants() {
      return Constants;
    },
    copiedSuccessfullyText() {
      return this.$t(Constants.link_copied_success_toast_message);
    },
    informationHeadingText() {
      return this.$t(Constants.information_heading);
    },
  },
  data() {
    return {
      modalTitle: "",
      modalShow: false,
      SelectedNonMandatory: [],
      editedFormData: {},
      currentCompanyList: [],
    };
  },
  components: {
    SignUpFormsListItem,
    SignUpFormsWizard,
    MyButton,
    MyInput,
    ToggleSimple,
    MyTextArea,
    SelectInputGroup,
    FileInput,
    NoDataBox,
    MyCheckbox,
  },
  methods: {
    getFormsImageUrl(partial) {
      const isValidUrl = common.isValidHttpUrl(partial);

      if (isValidUrl == true) {
        return partial;
      } else if (isValidUrl != true && partial != "") {
        return this.getUrl(partial);
      } else {
        const images = require.context("../../assets/imgs/", false, /\.png$/);
        return images("./placeholder.png");
      }
    },
    showEditForm(signUpFormId) {
      this.modalShow = !this.modalShow;
      this.fetchForm(signUpFormId);
    },
    deleteForm(signUpFormId) {
      this.$confirm(this.$t(this.LangConstants.delete_form_warning_message)).then(() => {
        this.$store.dispatch("deleteSignUpForm", signUpFormId);
      });
    },
    copyFormUrl(signUpFormId) {
      const signUpForm = this.$store.getters.signUpFormById(signUpFormId);
      if (signUpForm) {
        navigator.clipboard.writeText(this.$store.getters.spInstanceVueURL + signUpForm[0].url);

        this.$bvToast.toast(this.copiedSuccessfullyText, {
          title: this.informationHeadingText,
          autoHideDelay: 2000,
          appendToast: false,
        });

        // common.propose();
      }
    },
    getUrl(partial) {
      return this.$store.getters.storageUrl + partial;
    },

    addNonMandatoryField(value) {
      if (!this.SelectedNonMandatory.includes(value) && value != null) {
        this.SelectedNonMandatory.push(value);
      }
    },

    deleteNonMandatoryField(value) {
      if (this.SelectedNonMandatory.includes(value)) {
        this.SelectedNonMandatory = this.SelectedNonMandatory.filter((element) => element !== value);
      }
    },

    async fetchForm(signupFormId) {
      const form = await this.$store.getters.signUpFormById(signupFormId);
      this.modalTitle = this.$t(this.LangConstants.update_form_heading) + " " + form[0].title;

      this.editedFormData.form_id = signupFormId;

      this.$refs.customTitle.text = form[0].title;
      this.$refs.customDescription.text = form[0].description;

      // await common
      //   .getBase64FromFile(this.$refs.ulogo.filelist[0])
      //   .then((data) => {
      //     this.editedFormData.logo  = data;
      // });

      this.SelectedNonMandatory = [];
      this.currentCompanyList = "";
   
      for (let i = 0; i < form[0].sign_up_form_has_custom_field.length; i++) {
        if (form[0].sign_up_form_has_custom_field[i].sign_up_form_custom_field.mandatory == false) {
          console.log(form[0].sign_up_form_has_custom_field[i].sign_up_form_custom_field);
          if (form[0].sign_up_form_has_custom_field[i].sign_up_form_custom_field.id == 7) {

            if (form[0].sign_up_form_has_custom_field[i].value == null) {
              this.currentCompanyList = "";
            } else if (Array.isArray(form[0].sign_up_form_has_custom_field[i].value)) {
              this.currentCompanyList = form[0].sign_up_form_has_custom_field[i].value.join("\n");
            } else {
              try {
                const parsedValue = JSON.parse(form[0].sign_up_form_has_custom_field[i].value);
                if (Array.isArray(parsedValue)) {
                  this.currentCompanyList = parsedValue.join("\n");
                } else {
                  this.currentCompanyList = form[0].sign_up_form_has_custom_field[i].value;
                }
              } catch (e) {
                console.log("error in parsing" + e);
                console.log("error in parsing" + form[0].sign_up_form_has_custom_field[i].value);
                console.log("error in parsing" + form[0].sign_up_form_has_custom_field[i].value);
              }
            }

          }
          this.SelectedNonMandatory.push(form[0].sign_up_form_has_custom_field[i].sign_up_form_custom_field.id);
        }
      }
    
      this.$refs.captcha.ischecked = form[0].captcha;
    },

    hideModal() {
      this.modalShow = false;
    },

    async updateForm() {
      this.editedFormData.title = this.$refs.customTitle.text;
      this.editedFormData.description = this.$refs.customDescription.text;
      this.editedFormData.logo = "";

      if (this.$refs.ulogo.filelist.length > 0) {
        await common.getBase64FromFile(this.$refs.ulogo.filelist[0]).then((data) => {
          this.editedFormData.logo = data;
        });
      }

      if (this.$refs.customCompanyList) {
        let companyinfo = this.$refs.customCompanyList[0].text;
        this.editedFormData.custom_company_list = companyinfo ? companyinfo.split("\n") : [];
      }

      this.editedFormData.non_mandatory_fields = this.SelectedNonMandatory;
      this.editedFormData.captcha = this.$refs.captcha.ischecked;
      this.$store.dispatch("updateSignUpForm", JSON.stringify(this.editedFormData)).then((form) => {
        if (form.success == true) {
          this.$fire({
            title: this.$t(form.message),
            // text: "text",
            type: "success",
            timer: 3000,
          }).then(() => {
            this.hideModal();
          });
        } else {
          this.$fire({
            title: this.$t(form.message),
            // text: "text",
            type: "error",
            timer: 3000,
          });
        }
      });
    },
  },
};
</script>
